export default class StorageDriver {

    static data = new Map();

    static setItem(key, value) {
        return new Promise((resolve, reject) => {

            StorageDriver.data.set(key, value)

            return resolve();
        });
    }

    static getItem(key) {
        return new Promise((resolve, reject) => {

            let data = StorageDriver.data.get(key);

            return resolve(data);
        });
    }

}
